// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_3p-1";
export var movingGradient = "_3p-4";
export var movingGradientBlock = "_3p-2";
export var skeleton = "_3p-0";
export var skeletonText = "_3p-3";